import { render, staticRenderFns } from "./MyTables.vue?vue&type=template&id=a58010fa"
import script from "./MyTables.vue?vue&type=script&lang=js"
export * from "./MyTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports